<div class="bg-gray-50" [class.equipment-rental-shell]="isEquipmentRentalPage"
    style="font-family: 'Poppins', sans-serif;">
    <!-- Navbar Glass untuk Home Page (Fixed sticky on scroll dengan efek glass & transisi ke putih) -->
    <header *ngIf="isHomePage"
        class="home-glass-header fixed top-0 left-0 right-0 z-50 transition-all duration-300 ease-in-out"
        [class.glass-active]="isScrolled && !isPastHero" [class.navbar-light]="isPastHero" [ngClass]="isPastHero 
            ? 'bg-white shadow-md border-b border-gray-100 py-2.5 md:py-3' 
            : (isScrolled 
                ? 'bg-[#102B51]/85 backdrop-blur-lg border-b border-white/15 shadow-[0_8px_32px_rgba(0,0,0,0.25)] py-2.5 md:py-3' 
                : 'bg-transparent border-b border-transparent shadow-none py-3.5 md:py-5')">
        <nav class="relative z-10 px-4 md:px-8">
            <div class="max-w-8xl mx-auto flex items-center justify-between">
                <div class="cursor-pointer w-32 md:w-36 flex-shrink-0 transition-transform duration-200 hover:scale-[1.02]"
                    (click)="goToHome()">
                    <img src="/assets/visidea/Asset 1.svg" class="w-32 md:w-36 h-auto"
                        alt="Visidea Logo">
                </div>

                <!-- Menu Navigation -->
                <div id="mobileMenu"
                    class="hidden lg:flex lg:flex-1 lg:justify-center">
                    <div class="flex flex-row items-center justify-center gap-2.5 xl:gap-5 text-xs xl:text-sm transition-colors duration-300"
                        [ngClass]="isPastHero ? 'text-[#102B51]' : 'text-white'">

                        <div (click)="goToHome()" [class.nav-active]="isRouteActive('/')"
                            [ngClass]="isPastHero ? 'hover:text-emerald-600 lg:hover:text-[#102B51]' : 'hover:text-emerald-300 lg:hover:text-white lg:hover:opacity-80'"
                            class="transition cursor-pointer px-1.5 py-1 whitespace-nowrap">
                            {{ 'nav.home' | transloco }}</div>

                        <!-- Package Page Nav Item (Beside Home) -->
                        <div (click)="goToPackage()" [class.nav-active]="isRouteActive('/package')"
                            [ngClass]="isPastHero ? 'hover:text-emerald-600 lg:hover:text-[#102B51]' : 'hover:text-emerald-300 lg:hover:text-white lg:hover:opacity-80'"
                            class="transition cursor-pointer px-1.5 py-1 whitespace-nowrap">
                            {{ 'nav.package' | transloco }}</div>

                        <div (click)="goToDigitalInvitation()" [class.nav-active]="isRouteActive('/digital-invitation')"
                            [ngClass]="isPastHero ? 'hover:text-emerald-600 lg:hover:text-[#102B51]' : 'hover:text-emerald-300 lg:hover:text-white lg:hover:opacity-80'"
                            class="transition cursor-pointer px-1.5 py-1 whitespace-nowrap">
                            {{ 'nav.digital_invitation' | transloco }}</div>

                        <!-- Guest Book (sebelah kanan digital invitation) -->
                        <div (click)="goToGuestBook()" [class.nav-active]="isRouteActive('/guest-book')"
                            [ngClass]="isPastHero ? 'hover:text-emerald-600 lg:hover:text-[#102B51]' : 'hover:text-emerald-300 lg:hover:text-white lg:hover:opacity-80'"
                            class="transition cursor-pointer px-1.5 py-1 whitespace-nowrap">
                            {{ 'nav.guest_book' | transloco }}</div>

                        <div class="relative group w-full lg:w-auto">
                            <div (click)="toggleDropdown($event)" role="button" tabindex="0" (keydown.enter)="toggleDropdown($event)"
                                [class.nav-active]="isRouteActive('/photobooth')"
                                [ngClass]="isPastHero ? 'hover:text-emerald-600 lg:hover:text-[#102B51]' : 'hover:text-emerald-300 lg:hover:text-white lg:hover:opacity-80'"
                                class="transition flex items-center gap-2 justify-center lg:justify-start cursor-pointer whitespace-nowrap px-1.5 py-1"
                                id="dropdownDefaultButton">
                                {{ 'nav.photobooth' | transloco }}
                                <img src="/assets/visidea/arrow_dropdown.png"
                                    class="w-4 h-4 transition-all duration-300"
                                    [style.filter]="isPastHero ? 'none' : 'brightness(0) invert(1)'" alt="">
                            </div>
                            <!-- Mega Menu Dropdown -->
                            <div id="dropdown" [ngClass]="{'block': isDropdownOpen, 'hidden': !isDropdownOpen}"
                                class="static lg:absolute lg:top-[calc(100%+1rem)] lg:left-1/2 lg:-translate-x-1/2 mt-4 lg:mt-0 bg-white text-gray-800 rounded-3xl shadow-[0_20px_50px_-12px_rgba(0,0,0,0.3)] w-full lg:w-[50vw] lg:max-w-[800px] z-[60] overflow-hidden border border-gray-100 transition-all duration-300">
                                <div class="flex flex-col lg:flex-row h-full">
                                    <!-- Left Side - Illustration (Hidden on Mobile) -->
                                    <div
                                        class="hidden lg:flex lg:w-5/12 bg-gradient-to-br from-[#F4F7FF] to-[#E2E8F0] items-center justify-center p-8 relative overflow-hidden">
                                        <!-- Decorative blur elements for modern glass effect feeling -->
                                        <div
                                            class="absolute top-0 right-0 -mr-8 -mt-8 w-40 h-40 rounded-full bg-[#31E986]/20 blur-3xl">
                                        </div>
                                        <div
                                            class="absolute bottom-0 left-0 -ml-8 -mb-8 w-40 h-40 rounded-full bg-[#202367]/20 blur-3xl">
                                        </div>

                                        <!-- Dynamic Product Image - changes on hover -->
                                        <div class="relative z-10 w-full max-w-[200px]">
                                            <img [src]="getDropdownPhotoImage()"
                                                class="w-full aspect-[3/4] object-cover rounded-2xl drop-shadow-xl transition-all duration-300"
                                                alt="Photobooth Preview">
                                        </div>
                                    </div>

                                    <!-- Right Side - Product List -->
                                    <div
                                        class="w-full lg:w-7/12 p-3 lg:p-6 space-y-2 lg:space-y-3 bg-white max-h-[50vh] overflow-y-auto scrollbar-hide">
                                        <div (click)="goToPhotobooth(item)" *ngFor="let item of category"
                                            (mouseenter)="hoveredPhotoboothSlug = item.slug"
                                            (mouseleave)="hoveredPhotoboothSlug = ''"
                                            class="block p-4 rounded-2xl bg-white hover:bg-gradient-to-r hover:from-[#1B1E5B] hover:to-[#2A2E80] hover:shadow-xl transition-all duration-300 group/item cursor-pointer border border-gray-50 hover:border-transparent transform hover:-translate-y-1">
                                            <div class="flex items-center justify-between mb-1">
                                                <h4
                                                    class="text-lg font-bold text-[#102B51] group-hover/item:text-white transition-colors">
                                                    {{ item.name }}
                                                </h4>
                                                <span
                                                    class="opacity-0 group-hover/item:opacity-100 transition-opacity transform translate-x-[-10px] group-hover/item:translate-x-0">
                                                    <img src="/assets/visidea/arrow3.png"
                                                        class="w-5 h-5 brightness-0 invert" alt="">
                                                </span>
                                            </div>
                                            <p
                                                class="text-sm text-gray-500 group-hover/item:text-gray-300 leading-snug transition-colors">
                                                {{ item.short_description }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div (click)="goToVideobooth()" [class.nav-active]="isRouteActive('/videobooth')"
                            [ngClass]="isPastHero ? 'hover:text-emerald-600 lg:hover:text-[#102B51]' : 'hover:text-emerald-300 lg:hover:text-white lg:hover:opacity-80'"
                            class="transition cursor-pointer px-1.5 py-1 whitespace-nowrap">
                            {{ 'nav.videobooth' | transloco }}</div>

                        <!-- professional documentation -->
                        <div (click)="goToProfessionalPhotographer()"
                            [class.nav-active]="isRouteActive('/professional-photographer')"
                            [ngClass]="isPastHero ? 'hover:text-emerald-600 lg:hover:text-[#102B51]' : 'hover:text-emerald-300 lg:hover:text-white lg:hover:opacity-80'"
                            class="transition cursor-pointer px-1.5 py-1 whitespace-nowrap">
                            {{ 'nav.professional_documentation' | transloco }}</div>

                        <!-- smart ticketing -->
                        <div (click)="goToSmartTicketing()" [class.nav-active]="isRouteActive('/smart-ticketing')"
                            [ngClass]="isPastHero ? 'hover:text-emerald-600 lg:hover:text-[#102B51]' : 'hover:text-emerald-300 lg:hover:text-white lg:hover:opacity-80'"
                            class="transition cursor-pointer px-1.5 py-1 whitespace-nowrap">
                            {{ 'nav.smart_ticketing' | transloco }}</div>


                        <!-- equipment rental -->
                        <div (click)="goToEquipmentRental()" [class.nav-active]="isRouteActive('/equipment-rental')"
                            role="link" tabindex="0" (keydown.enter)="goToEquipmentRental()"
                            [attr.aria-current]="isRouteActive('/equipment-rental') ? 'page' : null"
                            [ngClass]="isPastHero ? 'hover:text-emerald-600 lg:hover:text-[#102B51]' : 'hover:text-emerald-300 lg:hover:text-white lg:hover:opacity-80'"
                            class="transition cursor-pointer px-1.5 py-1 whitespace-nowrap">
                            {{ 'nav.equipment_rental' | transloco }}</div>

                        <!-- EO -->
                        <div (click)="goToEO()" [class.nav-active]="isRouteActive('/event-organizer')"
                            [ngClass]="isPastHero ? 'hover:text-emerald-600 lg:hover:text-[#102B51]' : 'hover:text-emerald-300 lg:hover:text-white lg:hover:opacity-80'"
                            class="transition cursor-pointer px-1.5 py-1 whitespace-nowrap">
                            {{ 'nav.eo' | transloco }}</div>
                    </div>
                </div>

                <!-- Right Actions (Language & Cart - Desktop) -->
                <div class="hidden lg:flex items-center gap-3 justify-end flex-shrink-0">
                    <!-- Language Switcher -->
                    <div [ngClass]="isPastHero ? 'bg-gray-100 border-gray-200' : 'bg-white/10 backdrop-blur-md border-white/20'"
                        class="flex items-center rounded-full p-1 border text-xs font-semibold transition-all duration-300">
                        <button (click)="setLanguage('id')"
                            [ngClass]="isPastHero 
                                ? (currentLang === 'id' ? 'bg-[#102B51] text-white shadow-sm font-bold' : 'text-gray-600 hover:text-[#102B51]') 
                                : (currentLang === 'id' ? 'bg-white text-[#102B51] shadow-sm font-bold' : 'text-white/80 hover:text-white')"
                            class="px-2.5 py-1 rounded-full transition-all duration-200 flex items-center gap-1 cursor-pointer">
                            <span>ID</span>
                        </button>
                        <button (click)="setLanguage('en')"
                            [ngClass]="isPastHero 
                                ? (currentLang === 'en' ? 'bg-[#102B51] text-white shadow-sm font-bold' : 'text-gray-600 hover:text-[#102B51]') 
                                : (currentLang === 'en' ? 'bg-white text-[#102B51] shadow-sm font-bold' : 'text-white/80 hover:text-white')"
                            class="px-2.5 py-1 rounded-full transition-all duration-200 flex items-center gap-1 cursor-pointer">
                            <span>EN</span>
                        </button>
                    </div>

                    <!-- Shopping Cart Button (Desktop) -->
                    <button (click)="toggleCart()" data-cart-target [class.cart-added-bounce]="isCartAnimating"
                        [ngClass]="isPastHero 
                            ? 'bg-gray-100 hover:bg-gray-200 border-gray-200 text-[#102B51]' 
                            : 'bg-white/10 hover:bg-white/20 backdrop-blur-md border-white/20 text-white'"
                        class="relative p-2.5 rounded-full border transition flex items-center justify-center cursor-pointer group/cart">
                        <svg class="w-5 h-5 group-hover/cart:scale-110 transition-transform" fill="none"
                            stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
                        </svg>
                        <span *ngIf="totalCartQty > 0"
                            class="absolute -top-1 -right-1 bg-emerald-500 text-white text-[10px] font-extrabold w-5 h-5 rounded-full flex items-center justify-center shadow-lg animate-pulse border-2"
                            [ngClass]="isPastHero ? 'border-white' : 'border-[#102B51]'">
                            {{ totalCartQty }}
                        </span>
                    </button>
                </div>

                <!-- Mobile Action Buttons -->
                <div class="flex lg:hidden items-center gap-2 z-50 relative">
                    <!-- Mobile Cart Button -->
                    <button (click)="toggleCart()" data-cart-target [class.cart-added-bounce]="isCartAnimating"
                        [ngClass]="isPastHero 
                            ? 'bg-gray-100 text-[#102B51] border border-gray-200 shadow-sm' 
                            : 'bg-white/10 text-white border border-white/20'"
                        class="relative p-2 rounded-full flex items-center justify-center cursor-pointer transition-colors">
                        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
                        </svg>
                        <span *ngIf="totalCartQty > 0"
                            class="absolute -top-1 -right-1 bg-emerald-500 text-white text-[10px] font-extrabold w-5 h-5 rounded-full flex items-center justify-center shadow-md">
                            {{ totalCartQty }}
                        </span>
                    </button>

                    <!-- Mobile Menu Button -->
                    <button type="button" (click)="toggleMobileMenu()" id="mobileMenuBtn"
                        class="studio-menu-toggle p-2 rounded-full transition-colors"
                        [ngClass]="isPastHero ? 'text-[#102B51] hover:bg-gray-100' : 'text-white hover:bg-white/10'"
                        [attr.aria-expanded]="isMobileMenuOpen" aria-controls="studio-mobile-navigation"
                        [attr.aria-label]="currentLang === 'en' ? 'Open navigation' : 'Buka navigasi'">
                        <svg [ngClass]="{'hidden': isMobileMenuOpen}" id="menuIcon" class="w-6 h-6" fill="none"
                            stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M4 6h16M4 12h16M4 18h16" />
                        </svg>
                        <svg [ngClass]="{'block': isMobileMenuOpen, 'hidden': !isMobileMenuOpen}" id="closeIcon"
                            class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>
            </div>
        </nav>
    </header>

    <!-- Hero Section untuk Home Page (dengan background banner) -->
    <section *ngIf="isHomePage" class="relative pt-24 pb-10 md:pt-28 md:pb-18 overflow-hidden hero-section">

        <!-- Background Video / Image Container -->
        <div class="absolute inset-0 z-0 overflow-hidden pointer-events-none">
            <video #heroVideo *ngIf="isVideo(getCurrentSlide().image)" [src]="getCurrentSlide().image" autoplay
                [muted]="true" muted loop playsinline webkit-playsinline preload="auto"
                (loadedmetadata)="playVideo($event)" (canplay)="playVideo($event)" (loadeddata)="playVideo($event)"
                class="w-full h-full object-cover"
                style="transform: translateZ(0); will-change: transform; backface-visibility: hidden;">
            </video>
            <div *ngIf="!isVideo(getCurrentSlide().image)" class="w-full h-full bg-cover bg-center"
                [ngClass]="{'pan-animation': isSliding}"
                [style.background-image]="'url(' + getCurrentSlide().image + ')'"
                style="background-size: cover; transform: translateZ(0);">
            </div>
            <!-- Background Overlay for text readability - subtle gradient instead of flat opacity -->
            <div class="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-black/20"></div>
        </div>

        <!-- Main Content Container -->
        <div class="max-w-7xl mx-auto px-4 md:px-10 lg:px-2 flex flex-col justify-between relative z-0"
            style="min-height: calc(100vh - 120px)">
            <!-- Social Media Icons - Desktop Only (Vertical Right Side) -->
            <div class="hidden md:flex flex-col items-end gap-4 mt-8 md:mt-16">
                <!-- Instagram -->
                <a href="https://www.instagram.com/visideastudio/" target="_blank"
                    class="w-10 h-10 bg-white rounded-full flex items-center justify-center hover:bg-gray-100 transition">
                    <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                        <path
                            d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                    </svg>
                </a>
                <!-- TikTok -->
                <a href="https://www.tiktok.com/@visidea.studio" target="_blank"
                    class="w-10 h-10 bg-white rounded-full flex items-center justify-center hover:bg-gray-100 transition">
                    <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                        <path
                            d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
                    </svg>
                </a>
                <!-- WhatsApp -->
                <a [href]="whatsappUrl" (click)="whatsapp(); $event.preventDefault()" target="_blank"
                    class="w-10 h-10 bg-white rounded-full flex items-center justify-center hover:bg-gray-100 transition cursor-pointer">
                    <svg class="w-5 h-5 fill-current text-gray-800" viewBox="0 0 24 24">
                        <path
                            d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
                    </svg>
                </a>
            </div>

            <!-- Bottom Section -->
            <div class="mt-auto pb-10 md:pb-16">
                <!-- Counter and Content - Desktop Layout -->
                <div class="hidden md:flex justify-between items-center gap-8">
                    <div class="flex items-end gap-4">
                        <div class="text-xl md:text-2xl font-normal text-white">
                            {{ (currentSlide + 1).toString().padStart(2, '0') }}/{{ slides.length.toString().padStart(2,
                            '0') }}
                        </div>
                        <!-- Interactive Pagination -->
                        <div class="flex gap-2">
                            <div *ngFor="let slide of slides; let i = index" (click)="goToSlide(i)"
                                class="h-1 cursor-pointertransition-all duration-300 hover:bg-emerald-300"
                                [ngClass]="i === currentSlide ? 'w-12 bg-white' : 'w-8 bg-gray-500'">
                            </div>
                        </div>
                    </div>

                    <div class="flex items-center gap-2">
                        <button (click)="whatsapp()"
                            class="inline-flex items-center gap-2 bg-[#31E986] hover:bg-emerald-900 text-black px-6 md:px-8 py-3 rounded-full transition text-sm md:text-base whitespace-nowrap">
                            {{ 'hero.order_now' | transloco }}
                        </button>
                        <button (click)="nextSlide()"
                            class="w-12 h-12 bg-white rounded-full flex items-center justify-center hover:bg-gray-100 transition flex-shrink-0">
                            <img src="/assets/visidea/arrow.png" class="text-[#31E986]" alt="">
                        </button>
                    </div>
                </div>

                <!-- Mobile Layout -->
                <div class="md:hidden space-y-4">
                    <div class="flex items-center justify-between gap-4">
                        <div class="text-lg font-semibold text-white">
                            {{ (currentSlide + 1).toString().padStart(2, '0') }}/{{ slides.length.toString().padStart(2,
                            '0') }}
                        </div>
                    </div>

                    <!-- Mobile Pagination Dots -->
                    <div class="flex gap-2 justify-center">
                        <div *ngFor="let slide of slides; let i = index" (click)="goToSlide(i)"
                            class="h-1 cursor-pointertransition-all duration-300"
                            [ngClass]="i === currentSlide ? 'w-8 bg-white' : 'w-6 bg-gray-500'">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Navbar untuk Halaman Selain Home (dengan background putih, sticky on scroll) -->
    <section *ngIf="!isHomePage"
        class="public-navbar sticky top-0 left-0 right-0 z-50 bg-white py-2.5 md:py-3 border-b border-gray-100 shadow-md transition-all duration-300">
        <!-- Navigation -->
        <nav class="relative z-10 px-4 md:px-8">
            <div class="max-w-8xl mx-auto flex items-center justify-between">
                <div class="cursor-pointer w-32 md:w-36 flex-shrink-0 transition-transform duration-200 hover:scale-[1.02]"
                    (click)="goToHome()">
                    <img src="/assets/visidea/Asset 1.svg" class="w-32 md:w-36 h-auto" alt="Visidea Logo">
                </div>

                <!-- Menu Navigation -->
                <div id="mobileMenu2"
                    class="hidden lg:flex lg:flex-1 lg:justify-center">
                    <div
                        class="flex flex-row items-center justify-center gap-2.5 xl:gap-5 text-xs xl:text-sm transition-colors duration-300 text-[#102B51]">

                        <div (click)="goToHome()" [class.nav-active]="isRouteActive('/')"
                            class="transition cursor-pointer px-1.5 py-1 whitespace-nowrap hover:text-emerald-600 lg:hover:text-[#102B51]">
                            {{ 'nav.home' | transloco }}</div>

                        <!-- Package Page Nav Item (Beside Home) -->
                        <div (click)="goToPackage()" [class.nav-active]="isRouteActive('/package')"
                            class="transition cursor-pointer px-1.5 py-1 whitespace-nowrap hover:text-emerald-600 lg:hover:text-[#102B51]">
                            {{ 'nav.package' | transloco }}</div>

                        <div (click)="goToDigitalInvitation()" [class.nav-active]="isRouteActive('/digital-invitation')"
                            class="transition cursor-pointer px-1.5 py-1 whitespace-nowrap hover:text-emerald-600 lg:hover:text-[#102B51]">
                            {{ 'nav.digital_invitation' | transloco }}</div>

                        <!-- Guest Book (sebelah kanan digital invitation) -->
                        <div (click)="goToGuestBook()" [class.nav-active]="isRouteActive('/guest-book')"
                            class="transition cursor-pointer px-1.5 py-1 whitespace-nowrap hover:text-emerald-600 lg:hover:text-[#102B51]">
                            {{ 'nav.guest_book' | transloco }}</div>

                        <div class="relative group w-full lg:w-auto">
                            <div (click)="toggleDropdown($event)" role="button" tabindex="0" (keydown.enter)="toggleDropdown($event)"
                                [class.nav-active]="isRouteActive('/photobooth')"
                                class="transition flex items-center gap-2 justify-center lg:justify-start cursor-pointer whitespace-nowrap px-1.5 py-1 hover:text-emerald-600 lg:hover:text-[#102B51]"
                                id="dropdownDefaultButton2">
                                {{ 'nav.photobooth' | transloco }}
                                <img src="/assets/visidea/arrow_dropdown.png" class="w-4 h-4 transition-all duration-300 brightness-0 invert lg:brightness-100 lg:invert-0" alt="">
                            </div>
                            <!-- Mega Menu Dropdown -->
                            <div id="dropdown2" [ngClass]="{'block': isDropdownOpen, 'hidden': !isDropdownOpen}"
                                class="static lg:absolute lg:top-[calc(100%+1rem)] lg:left-1/2 lg:-translate-x-1/2 mt-4 lg:mt-0 bg-white text-gray-800 rounded-3xl shadow-[0_20px_50px_-12px_rgba(0,0,0,0.3)] w-full lg:w-[50vw] lg:max-w-[800px] z-[60] overflow-hidden border border-gray-100 transition-all duration-300">
                                <div class="flex flex-col lg:flex-row h-full">
                                    <!-- Left Side - Illustration (Hidden on Mobile) -->
                                    <div
                                        class="hidden lg:flex lg:w-5/12 bg-gradient-to-br from-[#F4F7FF] to-[#E2E8F0] items-center justify-center p-8 relative overflow-hidden">
                                        <!-- Decorative blur elements for modern glass effect feeling -->
                                        <div
                                            class="absolute top-0 right-0 -mr-8 -mt-8 w-40 h-40 rounded-full bg-[#31E986]/20 blur-3xl">
                                        </div>
                                        <div
                                            class="absolute bottom-0 left-0 -ml-8 -mb-8 w-40 h-40 rounded-full bg-[#202367]/20 blur-3xl">
                                        </div>

                                        <!-- Dynamic Product Image - changes on hover -->
                                        <div class="relative z-10 w-full max-w-[200px]">
                                            <img [src]="getDropdownPhotoImage()"
                                                class="w-full aspect-[3/4] object-cover rounded-2xl drop-shadow-xl transition-all duration-300"
                                                alt="Photobooth Preview">
                                        </div>
                                    </div>

                                    <!-- Right Side - Product List -->
                                    <div
                                        class="w-full lg:w-7/12 p-3 lg:p-6 space-y-2 lg:space-y-3 bg-white max-h-[50vh] overflow-y-auto scrollbar-hide">
                                        <div (click)="goToPhotobooth(item)" *ngFor="let item of category"
                                             (mouseenter)="hoveredPhotoboothSlug = item.slug"
                                             (mouseleave)="hoveredPhotoboothSlug = ''"
                                             class="block p-4 rounded-2xl bg-white hover:bg-gradient-to-r hover:from-[#1B1E5B] hover:to-[#2A2E80] hover:shadow-xl transition-all duration-300 group/item cursor-pointer border border-gray-50 hover:border-transparent transform hover:-translate-y-1">
                                            <div class="flex items-center justify-between mb-1">
                                                <h4
                                                    class="text-lg font-bold text-[#102B51] group-hover/item:text-white transition-colors">
                                                    {{ item.name }}
                                                </h4>
                                                <span
                                                    class="opacity-0 group-hover/item:opacity-100 transition-opacity transform translate-x-[-10px] group-hover/item:translate-x-0">
                                                    <img src="/assets/visidea/arrow3.png"
                                                        class="w-5 h-5 brightness-0 invert" alt="">
                                                </span>
                                            </div>
                                            <p
                                                class="text-sm text-gray-500 group-hover/item:text-gray-300 leading-snug transition-colors">
                                                {{ item.short_description }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div (click)="goToVideobooth()" [class.nav-active]="isRouteActive('/videobooth')"
                            class="transition cursor-pointer px-1.5 py-1 whitespace-nowrap hover:text-emerald-600 lg:hover:text-[#102B51]">
                            {{ 'nav.videobooth' | transloco }}</div>

                        <!-- professional documentation -->
                        <div (click)="goToProfessionalPhotographer()"
                            [class.nav-active]="isRouteActive('/professional-photographer')"
                            class="transition cursor-pointer px-1.5 py-1 whitespace-nowrap hover:text-emerald-600 lg:hover:text-[#102B51]">
                            {{ 'nav.professional_documentation' | transloco }}</div>

                        <!-- smart ticketing -->
                        <div (click)="goToSmartTicketing()" [class.nav-active]="isRouteActive('/smart-ticketing')"
                            class="transition cursor-pointer px-1.5 py-1 whitespace-nowrap hover:text-emerald-600 lg:hover:text-[#102B51]">
                            {{ 'nav.smart_ticketing' | transloco }}</div>

                        <!-- equipment rental -->
                        <div (click)="goToEquipmentRental()" [class.nav-active]="isRouteActive('/equipment-rental')"
                            role="link" tabindex="0" (keydown.enter)="goToEquipmentRental()"
                            [attr.aria-current]="isRouteActive('/equipment-rental') ? 'page' : null"
                            class="transition cursor-pointer px-1.5 py-1 whitespace-nowrap hover:text-emerald-600 lg:hover:text-[#102B51]">
                            {{ 'nav.equipment_rental' | transloco }}</div>

                        <!-- EO -->
                        <div (click)="goToEO()" [class.nav-active]="isRouteActive('/event-organizer')"
                            class="transition cursor-pointer px-1.5 py-1 whitespace-nowrap hover:text-emerald-600 lg:hover:text-[#102B51]">
                            {{ 'nav.eo' | transloco }}</div>

                    </div>
                </div>

                <!-- Right Actions (Language & Cart - Desktop Inner Page) -->
                <div class="hidden lg:flex items-center gap-3 justify-end flex-shrink-0">
                    <!-- Language Switcher -->
                    <div
                        class="flex items-center bg-gray-100 border border-gray-200 rounded-full p-1 text-xs font-semibold transition-all duration-300">
                        <button (click)="setLanguage('id')"
                            [ngClass]="currentLang === 'id' ? 'bg-[#102B51] text-white shadow-sm font-bold' : 'text-gray-600 hover:text-[#102B51]'"
                            class="px-2.5 py-1 rounded-full transition-all duration-200 flex items-center gap-1 cursor-pointer">
                            <span>ID</span>
                        </button>
                        <button (click)="setLanguage('en')"
                            [ngClass]="currentLang === 'en' ? 'bg-[#102B51] text-white shadow-sm font-bold' : 'text-gray-600 hover:text-[#102B51]'"
                            class="px-2.5 py-1 rounded-full transition-all duration-200 flex items-center gap-1 cursor-pointer">
                            <span>EN</span>
                        </button>
                    </div>

                    <!-- Shopping Cart Button (Desktop Inner Page) -->
                    <button (click)="toggleCart()" data-cart-target [class.cart-added-bounce]="isCartAnimating"
                        class="relative p-2.5 rounded-full bg-gray-100 hover:bg-gray-200 border border-gray-200 text-[#102B51] transition flex items-center justify-center cursor-pointer group/cart">
                        <svg class="w-5 h-5 group-hover/cart:scale-110 transition-transform" fill="none"
                            stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
                        </svg>
                        <span *ngIf="totalCartQty > 0"
                            class="absolute -top-1 -right-1 bg-emerald-500 text-white text-[10px] font-extrabold w-5 h-5 rounded-full flex items-center justify-center shadow-lg animate-pulse border-2 border-white">
                            {{ totalCartQty }}
                        </span>
                    </button>
                </div>

                <!-- Mobile Action Buttons (Inner Page) -->
                <div class="flex lg:hidden items-center gap-2 z-50 relative">
                    <!-- Mobile Cart Button -->
                    <button (click)="toggleCart()" data-cart-target [class.cart-added-bounce]="isCartAnimating"
                        class="relative p-2 rounded-full bg-gray-100 text-[#102B51] flex items-center justify-center cursor-pointer">
                        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
                        </svg>
                        <span *ngIf="totalCartQty > 0"
                            class="absolute -top-1 -right-1 bg-emerald-500 text-white text-[10px] font-extrabold w-5 h-5 rounded-full flex items-center justify-center shadow-md">
                            {{ totalCartQty }}
                        </span>
                    </button>

                    <!-- Mobile Menu Button -->
                    <button type="button" (click)="toggleMobileMenu()" id="mobileMenuBtn2" class="studio-menu-toggle"
                        [attr.aria-expanded]="isMobileMenuOpen" aria-controls="studio-mobile-navigation"
                        [attr.aria-label]="currentLang === 'en' ? 'Open navigation' : 'Buka navigasi'">
                        <svg [ngClass]="{'hidden': isMobileMenuOpen}" id="menuIcon2" class="w-6 h-6" fill="none"
                            stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M4 6h16M4 12h16M4 18h16" />
                        </svg>
                        <svg [ngClass]="{'block': isMobileMenuOpen, 'hidden': !isMobileMenuOpen}" id="closeIcon2"
                            class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>
            </div>
        </nav>
    </section>

    <div *ngIf="isMobileMenuOpen" class="studio-mobile-overlay">
        <div class="studio-mobile-backdrop" (click)="closeMobileMenu()" aria-hidden="true"></div>
        <section id="studio-mobile-navigation" class="studio-mobile-panel" role="dialog" aria-modal="true"
            aria-labelledby="studio-mobile-title" cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
            <header class="studio-mobile-header">
                <img src="/assets/visidea/logo-visidea2.svg" alt="Visidea Studio">
                <button type="button" class="studio-mobile-close" (click)="closeMobileMenu()" cdkFocusInitial
                    [attr.aria-label]="currentLang === 'en' ? 'Close navigation' : 'Tutup navigasi'">
                    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                        <path stroke-linecap="round" stroke-width="1.8" d="m6 6 12 12M6 18 18 6" />
                    </svg>
                </button>
            </header>
            <div class="studio-mobile-scroll">
                <div class="studio-mobile-intro">
                    <span>VISIDEA STUDIO</span>
                    <h2 id="studio-mobile-title">{{ currentLang === 'en' ? 'Explore our services' : 'Jelajahi layanan
                        kami' }}</h2>
                </div>
                <nav class="studio-mobile-links"
                    [attr.aria-label]="currentLang === 'en' ? 'Main navigation' : 'Navigasi utama'">
                    <a routerLink="/" (click)="closeMobileMenu()" [class.is-active]="isRouteActive('/')"
                        [attr.aria-current]="isRouteActive('/') ? 'page' : null">{{ 'nav.home' | transloco }}<span
                            aria-hidden="true">&#8599;</span></a>
                    <a routerLink="/package" (click)="closeMobileMenu()" [class.is-active]="isRouteActive('/package')"
                        [attr.aria-current]="isRouteActive('/package') ? 'page' : null">{{ 'nav.package' | transloco
                        }}<span aria-hidden="true">&#8599;</span></a>
                    <a routerLink="/digital-invitation" (click)="closeMobileMenu()"
                        [class.is-active]="isRouteActive('/digital-invitation')"
                        [attr.aria-current]="isRouteActive('/digital-invitation') ? 'page' : null">{{
                        'nav.digital_invitation' | transloco }}<span aria-hidden="true">&#8599;</span></a>
                    <a routerLink="/guest-book" (click)="closeMobileMenu()"
                        [class.is-active]="isRouteActive('/guest-book')"
                        [attr.aria-current]="isRouteActive('/guest-book') ? 'page' : null">{{ 'nav.guest_book' |
                        transloco }}<span aria-hidden="true">&#8599;</span></a>
                    <button type="button" (click)="toggleDropdown($event)"
                        [class.is-active]="isRouteActive('/photobooth')" [attr.aria-expanded]="isDropdownOpen"
                        aria-controls="studio-photobooth-submenu">
                        {{ 'nav.photobooth' | transloco }}
                        <svg class="studio-submenu-chevron" [class.is-expanded]="isDropdownOpen" fill="none"
                            stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="m6 9 6 6 6-6" />
                        </svg>
                    </button>
                    <div *ngIf="isDropdownOpen" id="studio-photobooth-submenu" class="studio-mobile-submenu">
                        <a routerLink="/photobooth" (click)="closeMobileMenu()">{{ currentLang === 'en' ? 'All
                            photobooths' : 'Semua photobooth' }}</a>
                        <a *ngFor="let item of category" [routerLink]="['/photobooth', item.slug]"
                            (click)="closeMobileMenu()"
                            [attr.aria-current]="isRouteActive('/photobooth/' + item.slug) ? 'page' : null">{{ item.name
                            }}</a>
                    </div>
                    <a *ngFor="let item of mobileServiceLinks" [routerLink]="item.route" (click)="closeMobileMenu()"
                        [class.is-active]="isRouteActive(item.route)"
                        [attr.aria-current]="isRouteActive(item.route) ? 'page' : null">
                        {{ item.label | transloco }}<span aria-hidden="true">&#8599;</span>
                    </a>
                </nav>
                <footer class="studio-mobile-footer">
                    <span>{{ currentLang === 'en' ? 'Language' : 'Bahasa' }}</span>
                    <div class="studio-mobile-language">
                        <button type="button" (click)="setLanguage('id')" [class.is-selected]="currentLang === 'id'"
                            [attr.aria-pressed]="currentLang === 'id'" aria-label="Bahasa Indonesia">ID</button>
                        <button type="button" (click)="setLanguage('en')" [class.is-selected]="currentLang === 'en'"
                            [attr.aria-pressed]="currentLang === 'en'" aria-label="English">EN</button>
                    </div>
                </footer>
            </div>
        </section>
    </div>

    <div class="relative">
        <div *ngIf="!isHomePage && !isDropdownOpen && !isDigitalInvitationThemeSelection() && !isRouteActive('/photobooth') && !isCareerJobDetailPage() && !isRouteActive('/digital-invitation/wedding-invitation')"
            class="banner-navigation" [class.banner-navigation--guest-book]="isRouteActive('/guest-book')"
            [class.banner-navigation--catalog]="isRouteActive('/package') || isRouteActive('/digital-invitation')">
            <div class="banner-navigation__container">
                <button type="button" (click)="goBack()" class="banner-back" aria-label="Kembali ke Beranda">
                    <span class="banner-back__icon" aria-hidden="true">
                        <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                        </svg>
                    </span>
                    <span>Kembali ke home
                    </span>
                </button>
            </div>
        </div>

        <!-- Main Content Rendered Here --->
        <router-outlet></router-outlet>
    </div>

    <section class="public-footer py-8 px-8"
        style="background-image: url('/assets/visidea/footer.png'); background-size: cover;">
        <div class="max-w-7xl mx-auto">
            <div class="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-16">
                <div class="flex justify-center items-center">
                    <img src="/assets/visidea/visidea_logo.png" class="w-48 md:w-75 mt-12" alt="">
                </div>
                <div class="space-y-4">
                    <div class="text-xl md:text-2xl text-white font-semibold">
                        {{ 'footer.connect_with_us' | transloco }}
                    </div>
                    <a class="group flex gap-4 items-center" href="https://www.instagram.com/visideastudio/">
                        <img src="/assets/visidea/instagram.png" class="w-8 h-8 bg-white rounded-full p-2" alt="">
                        <div class="text-base text-white group-hover:text-emerald-300 transition-colors duration-200">
                            visideastudio</div>
                    </a>
                    <a class="group flex gap-4 items-center" href="https://www.tiktok.com/@visidea.studio">
                        <img src="/assets/visidea/tik-tok.png" class="w-8 h-8 bg-white rounded-full p-2" alt="">
                        <div class="text-base text-white group-hover:text-emerald-300 transition-colors duration-200">
                            visidea.studio</div>
                    </a>
                    <a class="group flex gap-4 items-center cursor-pointer" [href]="whatsappUrl"
                        (click)="whatsapp(); $event.preventDefault()" target="_blank">
                        <img src="/assets/visidea/whatsapp.png" class="w-8 h-8 bg-white rounded-full p-2" alt="">
                        <div class="text-base text-white group-hover:text-emerald-300 transition-colors duration-200">
                            0822-6008-4847</div>
                    </a>
                    <a class="group flex gap-4 items-center"
                        href="https://www.google.com/maps/place/Selkachi+Photobooth+Summarecon+(Selka%EC%B9%98)/@-6.9569719,107.6947963,19.67z/data=!4m9!1m2!2m1!1sJl.+Bulevar+Utama+Ruby+Commercial+RC+172-178,+Summarecon+Bandung!3m5!1s0x2e68c30e88e84ebb:0x40711286e2cb45c0!8m2!3d-6.9574754!4d107.6948244!16s%2Fg%2F11yg692jhp?entry=ttu&g_ep=EgoyMDI2MDExMy4wIKXMDSoASAFQAw%3D%3D">
                        <img src="/assets/visidea/location.png" class="w-8 h-8 bg-white rounded-full p-2" alt="">
                        <div class="text-base text-white group-hover:text-emerald-300 transition-colors duration-200">
                            PT AWH Inti Nusantara
                        </div>
                    </a>
                </div>
                <div class="space-y-4">
                    <div class="text-xl md:text-2xl text-white font-semibold">
                        {{ 'footer.our_services' | transloco }}
                    </div>

                    <a (click)="goToAboutUs()"
                        class="block text-base text-white hover:text-emerald-300 transition-colors duration-200 cursor-pointer">
                        About Us
                    </a>
                    <a (click)="goToPartnership()"
                        class="block text-base text-white hover:text-emerald-300 transition-colors duration-200 cursor-pointer">
                        {{ 'footer.mitra' | transloco }}
                    </a>
                    <a (click)="goToCareer()"
                        class="block text-base text-white hover:text-emerald-300 transition-colors duration-200 cursor-pointer">
                        {{ 'footer.career' | transloco }}
                    </a>
                    <a (click)="goToReview()"
                        class="block text-base text-white hover:text-emerald-300 transition-colors duration-200 cursor-pointer">
                        Review
                    </a>
                    <a (click)="goToPortfolio()"
                        class="block text-base text-white hover:text-emerald-300 transition-colors duration-200 cursor-pointer">
                        Portofolio
                    </a>
                    <a (click)="goToEntertaint()"
                        class="block text-base text-white hover:text-emerald-300 transition-colors duration-200 cursor-pointer">
                        {{ 'footer.entertaint' | transloco }}
                    </a>
                </div>
            </div>
            <div class="text-sm md:text-base text-center text-white mt-8 md:mt-12">
                {{ 'footer.rights' | transloco }}
            </div>
        </div>
    </section>

    <button *ngIf="cartToast as toast" type="button" class="cart-added-toast" (click)="openCartFromToast()"
        [attr.aria-label]="'Buka keranjang: ' + toast.name" aria-live="polite">
        <img [src]="toast.image" [alt]="toast.name" class="cart-added-toast-image">
        <div class="min-w-0">
            <p class="cart-added-toast-title">Berhasil ditambahkan</p>
            <p class="cart-added-toast-name">{{ toast.name }}</p>
            <span class="cart-added-toast-action">Buka keranjang</span>
        </div>
        <span class="cart-added-toast-check" aria-hidden="true">&#10003;</span>
    </button>

    <!-- SLIDE-OVER SHOPPING CART DRAWER -->
    <div *ngIf="isCartOpen" class="fixed inset-0 z-[100] overflow-hidden">
        <!-- Backdrop Blur -->
        <div (click)="closeCart()"
            class="cart-drawer-backdrop absolute inset-0 bg-black/50 backdrop-blur-sm cursor-pointer"
            [class.is-closing]="isCartClosing"></div>

        <div class="fixed inset-y-0 right-0 max-w-full flex pl-10 pointer-events-none">
            <div class="cart-drawer-panel pointer-events-auto w-screen max-w-md bg-white shadow-2xl flex flex-col"
                [class.is-closing]="isCartClosing">

                <!-- Cart Drawer Header -->
                <div
                    class="p-6 bg-gradient-to-r from-[#102B51] to-[#202367] text-white flex items-center justify-between shadow-md">
                    <div class="flex items-center gap-3">
                        <div class="w-10 h-10 rounded-2xl bg-white/10 flex items-center justify-center">
                            <svg class="w-5 h-5 text-emerald-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
                            </svg>
                        </div>
                        <div>
                            <h3 class="text-lg font-bold">Keranjang Belanja</h3>
                            <p class="text-xs text-gray-300">{{ totalCartQty }} item dipilih</p>
                        </div>
                    </div>

                    <button (click)="closeCart()"
                        class="w-8 h-8 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center transition cursor-pointer">
                        ✕
                    </button>
                </div>

                <!-- Cart Items List (Scrollable) -->
                <div class="flex-1 overflow-y-auto p-6 space-y-4">
                    <!-- Empty State -->
                    <div *ngIf="cartItems.length === 0"
                        class="h-full flex flex-col items-center justify-center text-center py-12">
                        <div
                            class="w-20 h-20 rounded-full bg-gray-100 flex items-center justify-center text-gray-400 mb-4">
                            <svg class="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                                    d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
                            </svg>
                        </div>
                        <h4 class="text-lg font-bold text-gray-800">Keranjang Belanja Kosong</h4>
                        <p class="text-xs text-gray-500 mt-1 max-w-[240px]">
                            Anda belum menambahkan produk atau layanan apapun ke dalam keranjang.
                        </p>
                        <button (click)="closeCart()"
                            class="mt-6 px-6 py-2.5 bg-[#202367] text-white text-xs font-semibold rounded-full hover:bg-[#151745] transition cursor-pointer">
                            Mulai Belanja
                        </button>
                    </div>

                    <!-- Items List -->
                    <div *ngFor="let item of cartItems"
                        class="p-4 rounded-2xl bg-[#F8FAFC] border border-gray-100 flex gap-3.5 items-center hover:border-gray-200 transition">
                        <!-- Image Thumbnail -->
                        <img [src]="item.image" [alt]="item.name"
                            class="w-16 h-16 rounded-xl object-cover flex-shrink-0 border border-gray-200">

                        <div class="flex-1 min-w-0">
                            <h4 class="text-xs font-bold text-[#102B51] truncate">
                                {{ item.name }}
                            </h4>
                            <p *ngIf="item.category === 'Photobooth'"
                                class="text-[11px] text-gray-500 mt-1 leading-relaxed break-words">
                                Photobooth
                            </p>
                            <p *ngIf="item.category === 'Bundling Package' && item.description"
                                class="text-[11px] text-gray-600 mt-1 leading-relaxed break-words whitespace-pre-line">
                                {{ item.description }}
                            </p>
                            <p *ngIf="item.category && item.category !== 'Photobooth'"
                                class="text-[11px] text-gray-400 mt-0.5">
                                {{ item.category }}
                            </p>
                            <div *ngIf="item.category === 'Guest Book' && item.selectedAddons?.length"
                                class="mt-2 rounded-lg border border-emerald-100 bg-emerald-50/70 p-2.5">
                                <p class="mb-1.5 text-[10px] font-bold uppercase tracking-wide text-emerald-800">
                                    {{ item.selectedAddons?.length }} add-on dipilih
                                </p>
                                <div *ngFor="let addon of item.selectedAddons"
                                    class="flex items-start justify-between gap-2 py-0.5 text-[11px] text-gray-600">
                                    <span class="min-w-0">{{ addon.name }}</span>
                                    <span class="shrink-0 font-semibold">{{ cartService.formatCurrency(addon.price)
                                        }}</span>
                                </div>
                            </div>
                            <p *ngIf="item.category === 'Guest Book' && !item.selectedAddons?.length && item.selectedOption"
                                class="text-[11px] text-gray-500 mt-1 leading-relaxed break-words">
                                {{ item.selectedOption }}
                            </p>
                            <!-- Smart Ticketing Requested Domain Badge -->
                            <div *ngIf="item.custom_options?.requested_domain || item.custom_options?.domain"
                                class="mt-1.5 inline-flex items-center gap-1.5 px-2 py-0.5 rounded-lg bg-indigo-50 text-indigo-700 text-[10px] font-semibold border border-indigo-100">
                                <span>🌐</span>
                                <span>Domain: {{ item.custom_options?.requested_domain || item.custom_options?.domain
                                    }}</span>
                            </div>
                            <div class="text-xs font-bold text-emerald-700 mt-1">
                                {{ cartService.formatCurrency(item.price) }}
                            </div>

                            <!-- Quantity Controls -->
                            <div class="flex items-center gap-2 mt-2">
                                <div
                                    class="flex items-center bg-white rounded-lg border border-gray-200 overflow-hidden shadow-xs focus-within:border-emerald-500 focus-within:ring-1 focus-within:ring-emerald-500 transition-all">
                                    <button type="button" (click)="decrementCartQty(item)"
                                        class="px-2 py-0.5 text-xs text-gray-600 hover:bg-gray-100 active:bg-gray-200 cursor-pointer select-none"
                                        aria-label="Kurang kuantitas">
                                        -
                                    </button>
                                    <input type="number" [value]="item.qty" min="1"
                                        (input)="onCartQtyInput(item, $event)" (blur)="onCartQtyBlur(item, $event)"
                                        (keydown.enter)="onCartQtyEnter($event)" aria-label="Jumlah item"
                                        class="w-10 py-0.5 text-xs font-bold text-[#102B51] text-center border-0 focus:outline-none bg-transparent [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none">
                                    <button type="button" (click)="incrementCartQty(item)"
                                        class="px-2 py-0.5 text-xs text-gray-600 hover:bg-gray-100 active:bg-gray-200 cursor-pointer select-none"
                                        aria-label="Tambah kuantitas">
                                        +
                                    </button>
                                </div>
                                <span class="text-[11px] font-semibold text-gray-600">
                                    = {{ cartService.formatCurrency(item.price * item.qty) }}
                                </span>
                            </div>
                        </div>

                        <!-- Delete Item Button -->
                        <button (click)="removeCartItem(item)"
                            class="p-2 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-xl transition cursor-pointer"
                            title="Hapus Item">
                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                            </svg>
                        </button>
                    </div>
                </div>

                <!-- Cart Footer Summary & Actions -->
                <div *ngIf="cartItems.length > 0" class="p-6 bg-gray-50 border-t border-gray-100 space-y-4">
                    <div class="space-y-2 text-xs">
                        <div class="flex justify-between text-gray-500">
                            <span>Total Item</span>
                            <span class="font-bold text-gray-800">{{ totalCartQty }} Layanan</span>
                        </div>
                        <div class="flex justify-between text-gray-500">
                            <span>Subtotal</span>
                            <span class="font-bold text-gray-800">{{ cartService.formatCurrency(totalCartAmount)
                                }}</span>
                        </div>
                        <div class="flex justify-between text-gray-500 gap-2">
                            <span>Biaya Aplikasi (0.7%)</span>
                            <span class="font-bold text-gray-800 shrink-0">{{
                                cartService.formatCurrency(checkoutAdminFee) }}</span>
                        </div>
                        <div class="flex justify-between items-baseline pt-2 border-t border-gray-200">
                            <span class="text-sm font-bold text-gray-800">Total Pembayaran</span>
                            <span class="text-xl font-extrabold text-[#102B51]">
                                {{ cartService.formatCurrency(checkoutGrandTotal) }}
                            </span>
                        </div>
                    </div>

                    <div class="flex gap-2">
                        <button (click)="clearCart()"
                            class="py-3 px-3 border border-gray-300 hover:border-red-400 hover:bg-red-50 text-gray-600 hover:text-red-600 text-xs font-semibold rounded-2xl transition cursor-pointer">
                            Kosongkan
                        </button>

                        <button (click)="openCheckoutModal()"
                            class="flex-1 py-3 px-4 bg-gradient-to-r from-[#202367] to-[#102B51] hover:from-[#161845] hover:to-[#091b33] text-white text-xs md:text-sm font-bold rounded-2xl transition shadow-lg flex items-center justify-center gap-2 cursor-pointer active:scale-95">
                            <span>Checkout Sekarang</span>
                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M14 5l7 7m0 0l-7 7m7-7H3" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- CHECKOUT CUSTOMER & BOOKING MODAL -->
    <div *ngIf="isCheckoutModalOpen"
        class="fixed inset-0 z-[110] flex items-center justify-center p-3 sm:p-4 md:p-6 bg-black/60 backdrop-blur-sm animate-fade-in overflow-y-auto">
        <div
            class="bg-white rounded-3xl max-w-xl w-full max-h-[90vh] flex flex-col shadow-2xl border border-gray-100 my-auto overflow-hidden">
            <div class="p-6 pb-4 border-b border-gray-100 flex items-center justify-between shrink-0 bg-white">
                <div>
                    <h3 class="text-xl font-bold text-[#102B51]">Form Pemesanan & Booking</h3>
                    <p class="text-xs text-gray-500 mt-0.5">Email & No. WhatsApp akan digunakan untuk pengiriman invoice
                        dan konfirmasi pesanan</p>
                </div>
                <button (click)="closeCheckoutModal()"
                    class="w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-600 flex items-center justify-center transition cursor-pointer">
                    ✕
                </button>
            </div>

            <!-- Form Fields -->
            <div class="p-6 overflow-y-auto flex-1 space-y-4 text-xs md:text-sm">
                <!-- Name -->
                <div>
                    <label class="block font-semibold text-gray-700 mb-1">Nama Lengkap *</label>
                    <input type="text" [(ngModel)]="checkoutForm.name" placeholder="Contoh: Sarah Angelina"
                        class="w-full px-4 py-2.5 rounded-xl border border-gray-200 focus:border-[#202367] focus:ring-2 focus:ring-[#202367]/20 outline-none transition">
                </div>

                <!-- Email & WhatsApp -->
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    <div>
                        <label class="block font-semibold text-gray-700 mb-1">Email Aktif *</label>
                        <input type="email" [(ngModel)]="checkoutForm.email" placeholder="nama@email.com"
                            class="w-full px-4 py-2.5 rounded-xl border border-gray-200 focus:border-[#202367] focus:ring-2 focus:ring-[#202367]/20 outline-none transition">
                        <span class="text-[10px] text-gray-400 block mt-0.5">Untuk pengiriman invoice resmi</span>
                    </div>
                    <div>
                        <label class="block font-semibold text-gray-700 mb-1">No. WhatsApp Aktif *</label>
                        <input type="tel" [(ngModel)]="checkoutForm.phone" placeholder="Contoh: 081234567890"
                            class="w-full px-4 py-2.5 rounded-xl border border-gray-200 focus:border-[#202367] focus:ring-2 focus:ring-[#202367]/20 outline-none transition">
                        <span class="text-[10px] text-gray-400 block mt-0.5">Untuk notifikasi & tracking</span>
                    </div>
                </div>

                <!-- Event Details -->
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    <div>
                        <label class="block font-semibold text-gray-700 mb-1">Tanggal Acara (Opsional)</label>
                        <input type="date" [(ngModel)]="checkoutForm.eventDate"
                            class="w-full px-4 py-2.5 rounded-xl border border-gray-200 focus:border-[#202367] focus:ring-2 focus:ring-[#202367]/20 outline-none transition">
                    </div>
                    <div>
                        <label class="block font-semibold text-gray-700 mb-1">Lokasi / Kota Acara (Opsional)</label>
                        <input type="text" [(ngModel)]="checkoutForm.eventLocation"
                            placeholder="Contoh: Jakarta / Bandung"
                            class="w-full px-4 py-2.5 rounded-xl border border-gray-200 focus:border-[#202367] focus:ring-2 focus:ring-[#202367]/20 outline-none transition">
                    </div>
                </div>
                <!-- Custom Domain for Smart Ticketing -->
                <div *ngIf="hasSmartTicketingInCart()" class="mb-3">
                    <label class="block font-semibold text-gray-700 mb-1">Custom Domain (Khusus Undangan/Tiket)</label>
                    <input type="text" [(ngModel)]="checkoutForm.customDomain" placeholder="Contoh: weddingbudi.com"
                        class="w-full px-4 py-2.5 rounded-xl border border-gray-200 focus:border-[#202367] focus:ring-2 focus:ring-[#202367]/20 outline-none transition">
                    <span class="text-[10px] text-gray-400 block mt-0.5">Isi jika Anda ingin menggunakan custom domain
                        sendiri.</span>
                </div>



                <!-- Booking / Payment Option Selection -->
                <div>
                    <label class="block font-semibold text-gray-700 mb-2">Pilihan Pembayaran & Booking *</label>
                    <div class="grid grid-cols-1 sm:grid-cols-3 gap-2.5">
                        <!-- Full Payment -->
                        <div (click)="checkoutForm.paymentOption = 'full'"
                            [ngClass]="checkoutForm.paymentOption === 'full' ? 'border-[#202367] bg-[#202367]/5 ring-2 ring-[#202367]/20' : 'border-gray-200 bg-white hover:border-gray-300'"
                            class="p-3 rounded-2xl border cursor-pointer transition flex flex-col justify-between">
                            <div class="flex items-center justify-between mb-1.5">
                                <span class="text-xs font-bold text-[#102B51]">Full Payment</span>
                                <div class="w-4 h-4 rounded-full border flex items-center justify-center"
                                    [ngClass]="checkoutForm.paymentOption === 'full' ? 'border-[#202367] bg-[#202367]' : 'border-gray-300'">
                                    <div *ngIf="checkoutForm.paymentOption === 'full'"
                                        class="w-1.5 h-1.5 bg-white rounded-full"></div>
                                </div>
                            </div>
                            <p class="text-[11px] text-gray-500 leading-tight">Bayar lunas 100% untuk proses langsung
                            </p>
                            <span class="text-xs font-bold text-emerald-600 mt-2">100% Total</span>
                        </div>

                        <!-- DP Options -->
                        <div (click)="checkoutForm.paymentOption = 'dp'"
                            [ngClass]="checkoutForm.paymentOption === 'dp' ? 'border-[#202367] bg-[#202367]/5 ring-2 ring-[#202367]/20' : 'border-gray-200 bg-white hover:border-gray-300'"
                            class="p-3 rounded-2xl border cursor-pointer transition flex flex-col justify-between">
                            <div class="flex items-center justify-between mb-1.5">
                                <span class="text-xs font-bold text-[#102B51]">Down Payment (DP)</span>
                                <div class="w-4 h-4 rounded-full border flex items-center justify-center"
                                    [ngClass]="checkoutForm.paymentOption === 'dp' ? 'border-[#202367] bg-[#202367]' : 'border-gray-300'">
                                    <div *ngIf="checkoutForm.paymentOption === 'dp'"
                                        class="w-1.5 h-1.5 bg-white rounded-full"></div>
                                </div>
                            </div>
                            <p class="text-[11px] text-gray-500 leading-tight">Booking tanggal dengan pilihan DP (20% -
                                80%)
                            </p>
                            <span class="text-xs font-bold text-blue-600 mt-2">Pilihan DP {{ checkoutForm.dpPercentage
                                }}%</span>
                        </div>

                    </div>
                </div>

                <!-- Dynamic Option Sub-Forms: DP Customizer -->
                <div *ngIf="checkoutForm.paymentOption === 'dp'"
                    class="p-4 rounded-2xl bg-blue-50/70 border border-blue-200 space-y-3 animate-fade-in">
                    <div class="flex items-center justify-between">
                        <label class="text-xs font-bold text-[#102B51]">Pilihan Persentase DP:</label>
                        <span class="text-xs font-extrabold px-2.5 py-1 bg-[#202367] text-white rounded-lg">{{
                            checkoutForm.dpPercentage }}%</span>
                    </div>

                    <!-- Preset DP Buttons -->
                    <div class="grid grid-cols-2 gap-2">
                        <button type="button" *ngFor="let pct of [50, 70]" (click)="checkoutForm.dpPercentage = pct"
                            [ngClass]="checkoutForm.dpPercentage === pct ? 'bg-[#202367] text-white shadow-sm' : 'bg-white text-gray-700 border border-gray-200 hover:bg-gray-100'"
                            class="py-1.5 text-xs font-bold rounded-xl transition cursor-pointer">
                            {{ pct }}%
                        </button>
                    </div>

                    <!-- Custom Range Slider -->
                    <div>
                        <div class="flex justify-between text-[11px] text-gray-500 mb-1">
                            <span>Minimal (20%)</span>
                            <span>Geser untuk atur nominal DP</span>
                            <span>Maksimal (80%)</span>
                        </div>
                        <input type="range" min="20" max="80" step="5" [(ngModel)]="checkoutForm.dpPercentage"
                            class="w-full accent-[#202367] cursor-pointer">
                    </div>

                    <!-- DP Breakdown Box -->
                    <div class="bg-white p-3 rounded-xl border border-blue-100 space-y-1.5 text-xs">
                        <div class="flex justify-between text-gray-600">
                            <span>Nominal DP ({{ checkoutForm.dpPercentage }}%):</span>
                            <span class="font-bold text-blue-700">{{ cartService.formatCurrency(checkoutGrandTotal *
                                (checkoutForm.dpPercentage / 100)) }}</span>
                        </div>
                        <div class="flex justify-between text-gray-500">
                            <span>Sisa Pelunasan ({{ 100 - checkoutForm.dpPercentage }}%):</span>
                            <span class="font-semibold text-gray-700">{{ cartService.formatCurrency(checkoutGrandTotal *
                                (1
                                - checkoutForm.dpPercentage / 100)) }}</span>
                        </div>
                    </div>
                </div>

                <!-- Dynamic Option Sub-Forms: Quotation / Price Negotiation Form -->
                <div *ngIf="checkoutForm.paymentOption === 'quotation'"
                    class="p-4 rounded-2xl bg-amber-50/70 border border-amber-200 space-y-3 animate-fade-in">
                    <div class="flex items-center gap-2">
                        <h4 class="text-xs font-bold text-amber-900">Form Pengajuan Negosiasi Harga & Penawaran</h4>
                    </div>

                    <div>
                        <label class="block text-xs font-semibold text-amber-950 mb-1">Target Budget / Harga yang
                            Diajukan (Rp)</label>
                        <input type="number" [(ngModel)]="checkoutForm.negotiationPrice"
                            placeholder="Masukkan target budget yang Anda harapkan..."
                            class="w-full px-3.5 py-2 text-xs rounded-xl border border-amber-200 bg-white focus:border-amber-500 focus:ring-2 focus:ring-amber-200 outline-none transition">
                        <span class="text-[10px] text-amber-700 block mt-0.5">Total estimasi katalog: {{
                            cartService.formatCurrency(totalCartAmount) }}</span>
                    </div>

                    <div>
                        <label class="block text-xs font-semibold text-amber-950 mb-1">Alasan Negosiasi & Kebutuhan
                            Spesifik</label>
                        <textarea [(ngModel)]="checkoutForm.negotiationNotes" rows="2"
                            placeholder="Contoh: Pemesanan multi-hari, penyesuaian durasi sesi, atau kebutuhan bundling instansi..."
                            class="w-full px-3.5 py-2 text-xs rounded-xl border border-amber-200 bg-white focus:border-amber-500 focus:ring-2 focus:ring-amber-200 outline-none transition resize-none"></textarea>
                    </div>
                </div>

                <!-- Notes -->
                <div>
                    <label class="block font-semibold text-gray-700 mb-1">Catatan Tambahan (Opsional)</label>
                    <textarea [(ngModel)]="checkoutForm.notes" rows="2"
                        placeholder="Tuliskan permintaan khusus / konsep acara..."
                        class="w-full px-4 py-2 rounded-xl border border-gray-200 focus:border-[#202367] focus:ring-2 focus:ring-[#202367]/20 outline-none transition resize-none"></textarea>
                </div>

                <!-- Order Summary Preview -->
                <div class="p-4 rounded-2xl bg-gray-50 border border-gray-100 space-y-2">
                    <div class="font-bold text-gray-700 text-xs flex justify-between">
                        <span>Ringkasan Item Pesanan:</span>
                        <span class="text-gray-500 font-normal">{{ totalCartQty }} Layanan</span>
                    </div>
                    <div *ngFor="let item of cartItems" class="flex justify-between text-xs text-gray-600 gap-2">
                        <span class="truncate">{{ item.name }} (x{{ item.qty }})</span>
                        <span class="font-semibold shrink-0">{{ cartService.formatCurrency(item.price * item.qty)
                            }}</span>
                    </div>

                    <div
                        class="pt-2 border-t border-gray-200 flex justify-between font-semibold text-xs text-gray-700 gap-2">
                        <span>Subtotal</span>
                        <span class="shrink-0">{{ cartService.formatCurrency(totalCartAmount) }}</span>
                    </div>

                    <div *ngIf="checkoutForm.paymentOption !== 'quotation'"
                        class="flex justify-between font-semibold text-[11px] text-gray-500 gap-2">
                        <span>Biaya Aplikasi (0.7%)</span>
                        <span class="shrink-0">{{ cartService.formatCurrency(checkoutAdminFee) }}</span>
                    </div>

                    <div class="pt-2 border-t border-gray-200 flex justify-between font-bold text-sm text-[#102B51]">
                        <span>Total Keseluruhan</span>
                        <span>{{ checkoutForm.paymentOption === 'quotation' ?
                            cartService.formatCurrency(totalCartAmount) : cartService.formatCurrency(checkoutGrandTotal)
                            }}</span>
                    </div>

                    <div *ngIf="checkoutForm.paymentOption === 'dp'"
                        class="flex justify-between font-bold text-xs text-blue-600 bg-blue-50 p-2 rounded-lg">
                        <span>Nominal DP {{ checkoutForm.dpPercentage }}% Yang Harus Dibayar:</span>
                        <span>{{ cartService.formatCurrency(checkoutGrandTotal * (checkoutForm.dpPercentage / 100))
                            }}</span>
                    </div>
                    <div *ngIf="checkoutForm.paymentOption === 'quotation'"
                        class="text-xs text-amber-800 bg-amber-50 p-2.5 rounded-lg font-medium space-y-1">
                        <div>Invoice akan diterbitkan dalam bentuk <strong>Surat Penawaran Resmi (Quotation
                                Proposal)</strong>.</div>
                        <div *ngIf="checkoutForm.negotiationPrice" class="font-bold text-amber-900">
                            Ajuan Negosiasi: {{ cartService.formatCurrency(checkoutForm.negotiationPrice) }}
                        </div>
                    </div>
                </div>
            </div>

            <!-- Action Buttons (Fixed Footer) -->
            <div class="p-6 pt-4 border-t border-gray-100 flex gap-3 shrink-0 bg-white">
                <button (click)="closeCheckoutModal()"
                    class="py-3 px-4 border border-gray-200 hover:bg-gray-50 text-gray-600 text-xs md:text-sm font-semibold rounded-2xl transition cursor-pointer">
                    Batal
                </button>
                <button (click)="submitCartCheckout()"
                    class="flex-1 py-3 px-4 bg-gradient-to-r from-[#202367] to-[#102B51] hover:from-[#161845] hover:to-[#091b33] text-white text-xs md:text-sm font-bold rounded-2xl transition shadow-lg flex items-center justify-center gap-2 cursor-pointer active:scale-95">
                    <span>Proses Pesanan & Buat Invoice</span>
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                </button>
            </div>
        </div>
    </div>

    <!-- OFFICIAL CART INVOICE MODAL -->
    <div *ngIf="isCartInvoiceModalOpen"
        class="fixed inset-0 z-[120] flex items-center justify-center p-3 sm:p-4 md:p-6 bg-black/70 backdrop-blur-md animate-fade-in overflow-y-auto">
        <div
            class="bg-white rounded-3xl max-w-2xl w-full max-h-[90vh] flex flex-col shadow-2xl border border-gray-200 my-auto overflow-hidden">

            <!-- Modal Actions Bar (Top) -->
            <div
                class="p-6 pb-4 border-b border-gray-100 flex items-center justify-between shrink-0 bg-white print:hidden">
                <div class="flex items-center gap-2">
                    <span class="w-3 h-3 rounded-full bg-emerald-500 inline-block animate-pulse"></span>
                    <span class="text-xs font-bold uppercase tracking-wider text-emerald-600">Invoice Resmi
                        Diterbitkan</span>
                </div>
                <button (click)="closeCartInvoiceModal()"
                    class="w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-600 flex items-center justify-center transition cursor-pointer">
                    ✕
                </button>
            </div>

            <!-- INVOICE DOCUMENT CONTAINER (PRINTABLE & SCROLLABLE BODY) -->
            <div id="cartInvoicePrintSection" class="p-6 overflow-y-auto flex-1 bg-white text-slate-800">
                <!-- Header -->
                <div
                    class="flex flex-col sm:flex-row sm:items-start sm:justify-between pb-6 border-b border-gray-200 gap-4">
                    <div>
                        <div class="flex items-center gap-2">
                            <h2 class="text-2xl font-black text-[#102B51] tracking-tight">VISIDEA STUDIO</h2>
                        </div>
                        <p class="text-xs text-gray-500 mt-1">Digital Invitation, PhotoBooth & Event Technology</p>
                        <p class="text-xs text-gray-500">WhatsApp: +62 822-6008-4847 | info&#64;visideastudio.com</p>
                    </div>
                    <div class="sm:text-right">
                        <div class="flex items-center gap-1.5 justify-end">
                            <span class="inline-block px-3 py-1 rounded-full text-[11px] font-extrabold tracking-wider"
                                [ngClass]="{
                                    'bg-emerald-100 text-emerald-800': cartInvoiceData?.isPaid,
                                    'bg-amber-100 text-amber-800 animate-pulse': cartInvoiceData?.isPendingPayment,
                                    'bg-blue-100 text-blue-800': cartInvoiceData?.paymentOption === 'quotation'
                                }">
                                {{ cartInvoiceData?.status }}
                            </span>
                            <button *ngIf="!cartInvoiceData?.isPaid && cartInvoiceData?.paymentOption !== 'quotation'"
                                (click)="checkPaymentStatusManual()" [disabled]="isCheckingManualStatus"
                                class="px-2 py-0.5 bg-amber-50 hover:bg-amber-100 border border-amber-200 text-amber-800 text-[10px] font-bold rounded-lg transition inline-flex items-center gap-1 cursor-pointer">
                                <span>🔄 Cek</span>
                            </button>
                        </div>
                        <div class="text-xs font-bold text-gray-700 mt-2">No. Invoice: <span
                                class="font-mono text-gray-900">{{ cartInvoiceData?.invoiceNumber }}</span></div>
                        <div class="text-xs text-gray-500">Tanggal: {{ cartInvoiceData?.invoiceDate }}</div>
                    </div>
                </div>

                <!-- Customer Details & Event Info -->
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 py-5 border-b border-gray-100 text-xs">
                    <div>
                        <div class="font-bold text-[#102B51] mb-1.5 uppercase tracking-wide">Informasi Pemesan:</div>
                        <p class="font-bold text-gray-900 text-sm">{{ cartInvoiceData?.customerName }}</p>
                        <p class="text-gray-600">Email: <span class="font-medium text-gray-800">{{
                                cartInvoiceData?.customerEmail }}</span></p>
                        <p class="text-gray-600">WhatsApp: <span class="font-medium text-gray-800">{{
                                cartInvoiceData?.customerPhone }}</span></p>
                    </div>
                    <div>
                        <div class="font-bold text-[#102B51] mb-1.5 uppercase tracking-wide">Detail Acara & Metode:
                        </div>
                        <p class="text-gray-600">Tanggal Acara: <span class="font-medium text-gray-800">{{
                                cartInvoiceData?.eventDate }}</span></p>
                        <p class="text-gray-600">Lokasi: <span class="font-medium text-gray-800">{{
                                cartInvoiceData?.eventLocation }}</span></p>
                        <p class="text-gray-600">Opsi Booking: <span class="font-bold text-indigo-700">{{
                                cartInvoiceData?.paymentTypeLabel }}</span></p>
                    </div>
                </div>

                <!-- Itemized Table -->
                <div class="py-5">
                    <table class="w-full text-xs">
                        <thead>
                            <tr
                                class="border-b-2 border-gray-200 text-left text-gray-500 uppercase tracking-wider text-[10px]">
                                <th class="pb-2">No</th>
                                <th class="pb-2">Layanan / Tema</th>
                                <th class="pb-2 text-center">Qty</th>
                                <th class="pb-2 text-right">Harga Satuan</th>
                                <th class="pb-2 text-right">Subtotal</th>
                            </tr>
                        </thead>
                        <tbody class="divide-y divide-gray-100">
                            <tr *ngFor="let item of cartInvoiceData?.items; let i = index" class="py-2.5">
                                <td class="py-2.5 text-gray-400 font-mono">{{ i + 1 }}</td>
                                <td class="py-2.5">
                                    <div class="font-bold text-gray-900">{{ item.name }}</div>
                                    <div *ngIf="item.category" class="text-[11px] text-gray-400">{{ item.category }}
                                    </div>
                                    <div *ngIf="item.custom_options?.requested_domain || item.custom_options?.domain"
                                        class="text-[10px] text-indigo-700 font-semibold mt-0.5 font-mono">
                                        🌐 Domain: https://{{ item.custom_options?.requested_domain ||
                                        item.custom_options?.domain }}
                                    </div>
                                </td>
                                <td class="py-2.5 text-center font-medium">{{ item.qty }}x</td>
                                <td class="py-2.5 text-right text-gray-600">{{ cartService.formatCurrency(item.price) }}
                                </td>
                                <td class="py-2.5 text-right font-bold text-gray-900">{{
                                    cartService.formatCurrency(item.price * item.qty) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- Financial Breakdown -->
                <div class="bg-gray-50 rounded-2xl p-4 border border-gray-200 space-y-2 text-xs">
                    <div class="flex justify-between text-gray-600">
                        <span>Total Biaya Layanan:</span>
                        <span class="font-bold text-gray-800">{{
                            cartService.formatCurrency(cartInvoiceData?.totalAmount) }}</span>
                    </div>

                    <div *ngIf="cartInvoiceData?.paymentOption === 'dp'"
                        class="flex justify-between text-blue-700 font-bold pt-1 border-t border-gray-200">
                        <span>Down Payment {{ cartInvoiceData?.dpPercentage }}% (Sudah Dibayarkan / Booking):</span>
                        <span>{{ cartService.formatCurrency(cartInvoiceData?.payAmount) }}</span>
                    </div>
                    <div *ngIf="cartInvoiceData?.paymentOption === 'dp'"
                        class="flex justify-between text-gray-500 font-medium">
                        <span>Sisa Pelunasan Sebelum Acara:</span>
                        <span>{{ cartService.formatCurrency(cartInvoiceData?.remainingAmount) }}</span>
                    </div>

                    <div *ngIf="cartInvoiceData?.paymentOption === 'full'"
                        class="flex justify-between text-emerald-700 font-extrabold text-sm pt-1 border-t border-gray-200">
                        <span>Total Pembayaran Lunas (100%):</span>
                        <span>{{ cartService.formatCurrency(cartInvoiceData?.payAmount) }}</span>
                    </div>

                    <div *ngIf="cartInvoiceData?.paymentOption === 'quotation'"
                        class="space-y-1.5 pt-1 border-t border-gray-200">
                        <div class="flex justify-between text-amber-800 font-bold">
                            <span>Estimasi Total Penawaran:</span>
                            <span>{{ cartService.formatCurrency(cartInvoiceData?.totalAmount) }}</span>
                        </div>
                        <div *ngIf="cartInvoiceData?.negotiationPrice"
                            class="flex justify-between text-emerald-700 font-bold bg-emerald-50 p-2 rounded-lg">
                            <span>Target Budget / Negosiasi Diajukan:</span>
                            <span>{{ cartService.formatCurrency(cartInvoiceData?.negotiationPrice) }}</span>
                        </div>
                        <div *ngIf="cartInvoiceData?.negotiationNotes"
                            class="text-gray-600 bg-gray-100 p-2 rounded-lg text-[11px]">
                            <span class="font-semibold text-gray-800">Catatan Negosiasi:</span> {{
                            cartInvoiceData?.negotiationNotes }}
                        </div>
                    </div>
                </div>

                <!-- QRIS / Payment Gateway Section -->
                <div *ngIf="cartInvoiceData?.qrCodeUrl && !cartInvoiceData?.isPaid"
                    class="mt-4 p-5 bg-gradient-to-br from-emerald-50 via-white to-emerald-50/50 rounded-2xl border-2 border-emerald-300 text-center space-y-3 shadow-md animate-fade-in">
                    <div class="flex items-center justify-center gap-2">
                        <span
                            class="px-3 py-1 bg-emerald-600 text-white font-black text-xs rounded-full tracking-wider uppercase shadow-xs flex items-center gap-1.5">
                            <span class="w-2 h-2 rounded-full bg-white animate-ping"></span>
                            QRIS Pembayaran Real-time
                        </span>
                    </div>

                    <!-- QR Code Image -->
                    <div class="flex flex-col items-center justify-center space-y-2 py-1">
                        <div
                            class="p-3.5 bg-white rounded-2xl shadow-lg border border-gray-200 inline-block transform hover:scale-105 transition-transform">
                            <img [src]="cartInvoiceData.qrCodeUrl" alt="QRIS Code Pembayaran"
                                class="w-52 h-52 sm:w-64 sm:h-64 object-contain mx-auto">
                        </div>
                        <p class="text-xs font-bold text-gray-800 max-w-xs mx-auto">Scan QRIS menggunakan BCA Mobile,
                            Livin, GoPay, OVO, ShopeePay, DANA, atau M-Banking</p>
                    </div>

                    <!-- Virtual Account option if present -->
                    <div *ngIf="cartInvoiceData?.virtualAccount"
                        class="p-3 bg-white rounded-xl border border-emerald-100 text-xs text-gray-700">
                        <span class="text-gray-500 block">Nomor Virtual Account:</span>
                        <span class="font-mono text-base font-extrabold text-[#102B51] select-all">{{
                            cartInvoiceData.virtualAccount }}</span>
                    </div>

                    <div
                        class="text-xs text-gray-700 bg-white p-3 rounded-xl border border-emerald-100 flex items-center justify-between font-semibold">
                        <span class="text-emerald-800">Nominal Tagihan Harus Dibayar:</span>
                        <span class="font-extrabold text-emerald-700 text-base">{{
                            cartService.formatCurrency(cartInvoiceData.payAmount) }}</span>
                    </div>

                    <div class="flex items-center justify-between pt-1">
                        <p class="text-[10px] text-gray-500 italic">Otomatis terverifikasi begitu pembayaran diterima.
                        </p>
                        <button (click)="checkPaymentStatusManual()" [disabled]="isCheckingManualStatus"
                            class="px-3 py-1.5 bg-emerald-600 hover:bg-emerald-700 text-white font-extrabold text-xs rounded-xl transition shadow-md flex items-center gap-1.5 cursor-pointer active:scale-95 disabled:opacity-50">
                            <span *ngIf="isCheckingManualStatus"
                                class="w-3.5 h-3.5 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                            <span>🔄 Cek Status Pembayaran</span>
                        </button>
                    </div>
                </div>

                <!-- Payment Success Banner -->
                <div *ngIf="cartInvoiceData?.isPaid"
                    class="mt-4 p-5 bg-emerald-50 rounded-2xl border-2 border-emerald-500 text-center space-y-2 animate-fade-in">
                    <div
                        class="w-12 h-12 rounded-full bg-emerald-500 text-white flex items-center justify-center mx-auto text-xl font-bold">
                        ✓</div>
                    <h4 class="text-base font-black text-emerald-900">Pembayaran Berhasil Diverifikasi (Lunas)!</h4>
                    <p class="text-xs text-emerald-700">Terima kasih, pembayaran sebesar <strong>{{
                            cartService.formatCurrency(cartInvoiceData.payAmount) }}</strong> telah diterima. Tim
                        Visidea Studio akan segera memproses pesanan Anda.</p>
                </div>

                <!-- Notice / Disclaimer -->
                <div
                    class="mt-4 p-3 bg-indigo-50/70 rounded-xl border border-indigo-100 text-[11px] text-indigo-900 space-y-1">
                    <p class="font-bold">Informasi Notifikasi & Pengiriman:</p>
                    <p>• Notifikasi pesanan serta berkas e-invoice resmi telah diteruskan ke alamat email: <strong>{{
                            cartInvoiceData?.customerEmail }}</strong></p>
                    <p>• Tim Visidea Studio akan menghubungi Anda melalui WhatsApp di <strong>{{
                            cartInvoiceData?.customerPhone }}</strong> untuk koordinasi teknis dan briefing materi.</p>
                </div>
            </div>

            <!-- Footer Action Buttons (Print / WA / Close - Fixed) -->
            <div
                class="p-6 pt-4 border-t border-gray-100 flex flex-col sm:flex-row gap-3 shrink-0 bg-white print:hidden">
                <button (click)="printCartInvoice()"
                    class="py-3 px-4 bg-gray-100 hover:bg-gray-200 text-gray-800 font-bold text-xs md:text-sm rounded-2xl transition flex items-center justify-center gap-2 cursor-pointer">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
                    </svg>
                    <span>Cetak / Simpan PDF</span>
                </button>

                <button (click)="sendCartInvoiceWhatsApp()"
                    class="flex-1 py-3 px-4 bg-[#25D366] hover:bg-[#20ba5a] text-white font-bold text-xs md:text-sm rounded-2xl transition shadow-lg flex items-center justify-center gap-2 cursor-pointer active:scale-95">
                    <svg class="w-5 h-5 fill-current" viewBox="0 0 24 24">
                        <path
                            d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
                    </svg>
                    <span>Konfirmasi via WhatsApp</span>
                </button>

                <button (click)="closeCartInvoiceModal()"
                    class="py-3 px-4 bg-[#102B51] hover:bg-[#0c2240] text-white font-bold text-xs md:text-sm rounded-2xl transition cursor-pointer">
                    Selesai
                </button>
            </div>
        </div>
    </div>
</div>